import { ACCOUNT_SERVICE_URL, CLASSTING_LEGACY_AUTH_URL } from '../../constants';
import { http } from '../../utils';

export const fetchUser = async () => http.get(`${ACCOUNT_SERVICE_URL}/me`);

export const fetchLegacyUser = async () => http.get(`${CLASSTING_LEGACY_AUTH_URL}/me`);
